var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 376,
    height: 375,
    viewBox: "0 0 376 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "163%",
    height: "167.3%",
    x: "-31.5%",
    y: "-33.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 22.489
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M224.888 242.129l-93.928-72.792c-11.478-7.897-26.675-7.94-38.198-.113C60.486 191.15 0 242.13 0 242.13h224.888z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M96.443 167.116h-.658L0 100.437V242.13s60.486-50.98 92.758-72.905c1.187-.804 2.432-1.47 3.685-2.108z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00C4B3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.625,
    cy: 187.578,
    opacity: 0.03,
    rx: 187.406,
    ry: 187.359
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.125,
    cy: 188.094,
    opacity: 0.04,
    rx: 124.938,
    ry: 124.906
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#053871",
    fillOpacity: 0.66,
    d: "M202.78 123.065l-76.264-74.46c-7.937-9.299-20.207-9.299-28.144 0l-76.264 74.46-11.534 118.396 214.314.668-22.109-119.064z",
    filter: "url(#a)",
    transform: "translate(75.181 48.945)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M300.069 147.535L208.307 57.77c-11.457-11.21-29.906-11.21-41.363 0L75.18 147.535v143.538H300.07V147.535z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DC50",
    d: "M168.79 216.34c.567-.615.175-6.685.175-6.685l6.422-.069 3.394-2.969.115-7.037.01-.007c-.096-.03 7.063-.003 7.063-.003l2.38-3.285s.188-6.39.237-6.442l6.564-.513 7-5.915c4.412 2.044 9.313 3.222 14.497 3.222 19.075 0 34.54-15.477 34.54-34.568.003-19.101-15.461-34.579-34.536-34.579-19.078 0-34.545 15.478-34.545 34.572 0 5.296 1.227 10.296 3.357 14.782l-39.555 39.319s-.046 16.645-.04 16.645l16.8.027s2.548-2.614 6.123-6.495zm46.15-70.874c0-4.526 3.69-8.193 8.241-8.193 4.552 0 8.246 3.667 8.246 8.193s-3.693 8.196-8.246 8.196c-4.552 0-8.242-3.67-8.242-8.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4C302",
    d: "M234.729 145.472c0-6.362-5.159-11.52-11.521-11.52-6.363 0-11.52 5.158-11.52 11.52 0 6.366 5.157 11.52 11.52 11.52 6.362 0 11.52-5.154 11.52-11.52zm-16.459 0a4.937 4.937 0 1 1 9.875 0 4.937 4.937 0 0 1-9.875 0zM190.628 174.754a34.619 34.619 0 0 1-6.373-10.766l-38.403 39.087v16.458l44.776-44.779z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.181 48.945)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C1E7E4",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.181 48.945)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D1F2F0",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEDBD7",
    d: "M204.284 216.06h-1.97c1.303.667 2.594 1.375 3.823 2.221l93.932 72.792V149.382l-95.785 66.678z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.455,
    cy: 269.818,
    r: 45.455,
    fill: "#7ED321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M266.182 269.352c0 1.407.482 2.603 1.446 3.587l14.547 14.494c.964.984 2.16 1.476 3.586 1.476 1.389 0 2.565-.492 3.529-1.476l29.933-29.934c1.003-.984 1.504-2.174 1.504-3.571 0-1.398-.501-2.579-1.504-3.543-1.002-.984-2.193-1.476-3.571-1.476-1.379 0-2.57.492-3.572 1.476l-26.319 26.362-10.99-10.982c-1.002-.984-2.193-1.476-3.571-1.476-1.379 0-2.57.492-3.572 1.476-.964.984-1.446 2.18-1.446 3.587z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateReady);
export default __webpack_public_path__ + "static/media/state-ready.4d83640efea38ab25ddbc175dcf826b1.svg";
export { ForwardRef as ReactComponent };